import { Link } from 'react-router-dom';
import Smiley from './Smiley.jsx';
import { WA_URL } from '../config.js';
import { trackWhatsApp } from '../analytics.js';

export default function HeroV1() {
  return (
    <div className="hv1" dir="rtl" lang="he">
      <style>{`
        .hv1 {
          width: 100%;
          background: var(--paper);
          display: flex;
          flex-direction: column;
          font-family: "Heebo", sans-serif;
          color: var(--ink);
          position: relative;
          overflow: clip;
        }

        .hv1-stage {
          flex: 1;
          display: grid;
          grid-template-columns: 1fr clamp(220px, 26vw, 320px);
          gap: clamp(16px, 3vw, 36px);
          padding: clamp(20px, 3.5vw, 40px) clamp(20px, 5vw, 64px) clamp(18px, 2.5vw, 30px);
          position: relative;
        }
        /* text RIGHT (col 1 = right in RTL), smiley LEFT (col 2) */
        @media (min-width: 881px) {
          .hv1-left  { grid-column: 1; }
          .hv1-right { grid-column: 2; }
        }
        /* Tablet: wider smiley col so chips fit */
        @media (max-width: 980px) and (min-width: 641px) {
          .hv1-stage { grid-template-columns: 1fr clamp(200px, 28vw, 260px); gap: 14px; padding: 20px 20px 16px; }
          .hv1-left  { grid-column: 1; }
          .hv1-right { grid-column: 2; order: 0; }
        }
        /* Mobile: 1 column — text takes full width (smiley hidden in later block) */
        @media (max-width: 640px) {
          .hv1-stage { grid-template-columns: 1fr; gap: 12px; padding: 16px 14px 14px; }
          .hv1-left  { grid-column: 1; }
        }
        .hv1-left { display: flex; flex-direction: column; justify-content: center; }
        .hv1-eyebrow-row {
          display: flex;
          gap: 12px;
          align-items: center;
          margin-bottom: 16px;
        }
        .hv1-eyebrow {
          font-family: "Space Grotesk", sans-serif;
          font-size: 13px;
          font-weight: 500;
          letter-spacing: 0.06em;
          color: var(--muted);
          text-transform: uppercase;
        }
        .hv1-eyebrow b { color: var(--ink); font-weight: 700; margin: 0 6px; }

        .hv1-h1 {
          font-family: "Heebo", sans-serif;
          font-weight: 900;
          font-size: clamp(32px, 5.5vw, 72px);
          line-height: 1.0;
          letter-spacing: -0.025em;
          margin: 0 0 clamp(14px, 2vw, 24px) 0;
          display: flex;
          flex-direction: column;
          gap: clamp(10px, 1.2vw, 18px);
          overflow: visible;
        }
        .hv1-h1 .line {
          display: flex;
          flex-wrap: wrap;
          align-items: baseline;
          gap: clamp(8px, 1.4vw, 18px);
        }
        .hv1-h1 .word { display: inline-block; }
        .hv1-h1 .dot { color: var(--coral); }

        .hv1-lede {
          font-size: clamp(14px, 1.4vw, 17px);
          line-height: 1.55;
          color: var(--ink-2);
          max-width: 620px;
          margin: 0 0 clamp(14px, 2vw, 24px) 0;
          font-weight: 400;
        }
        .hv1-lede strong { font-weight: 700; }

        .hv1-cta-row {
          display: flex;
          gap: 12px;
          align-items: center;
          margin-bottom: 20px;
          flex-wrap: wrap;
        }

        .hv1-capacity {
          display: inline-flex;
          align-items: center;
          gap: 12px;
          padding: 10px 18px;
          border: 1.5px solid var(--ink);
          border-radius: 999px;
          background: var(--cream);
          font-family: "Space Grotesk", sans-serif;
          font-size: 14px;
          font-weight: 500;
          width: fit-content;
        }
        .hv1-capacity .pulse {
          width: 9px; height: 9px; border-radius: 999px;
          background: var(--teal);
          box-shadow: 0 0 0 4px rgba(31,163,138,.2);
          animation: hv1pulse 2.4s ease-in-out infinite;
        }
        .hv1-capacity .sep { color: rgba(14,14,16,.3); }
        @keyframes hv1pulse {
          0%, 100% { opacity: 1; }
          50% { opacity: .55; }
        }

        .hv1-right {
          display: flex;
          flex-direction: column;
          align-items: flex-start;
          justify-content: center;
          padding: 12px 0 12px clamp(32px, 6vw, 80px);
          position: relative;
        }
        .hv1-smiley-wrap {
          position: relative;
          width: clamp(150px, 18vw, 230px);
          height: clamp(150px, 18vw, 230px);
          margin: 0;
        }
        /* ── Tablet: smiley centered, chips distributed symmetrically ── */
        @media (max-width: 980px) and (min-width: 641px) {
          .hv1-right {
            padding: 0;
            align-items: center;
            justify-content: center;
          }
          .hv1-smiley-wrap {
            width: clamp(72px, 9vw, 90px);
            height: clamp(72px, 9vw, 90px);
            margin: 0 auto;
          }
        }
        /* ── Mobile ≤640: smiley HIDDEN (text full-width) ── */
        @media (max-width: 640px) {
          .hv1-right { display: none !important; }
          .hv1-floats { display: none; }
          .hv1-stage { gap: 12px; }
          /* Eyebrow: one line only */
          .hv1-eyebrow-row { margin-bottom: 8px; }
          .hv1-eyebrow {
            font-size: 10px;
            letter-spacing: 0.03em;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            max-width: 100%;
          }
          /* H1: fit phone width */
          .hv1-h1 {
            font-size: clamp(26px, 9vw, 40px);
            gap: 4px;
            margin-bottom: 10px;
          }
          /* Lede: compact */
          .hv1-lede {
            font-size: 13px;
            margin-bottom: 12px;
          }
          /* CTA row */
          .hv1-cta-row { gap: 8px; margin-bottom: 12px; }
          .hv1-cta-row .btn { padding: 11px 16px; font-size: 14px; }
          /* Capacity */
          .hv1-capacity { font-size: 12px; padding: 7px 12px; gap: 8px; }
        }
        .hv1-smiley-wrap .blob {
          position: absolute;
          inset: -28px;
          background: var(--yellow-soft);
          border-radius: 50%;
          z-index: 0;
          filter: blur(0.5px);
        }
        .hv1-smiley-wrap .smy-svg {
          position: relative;
          width: 100%;
          height: 100%;
          z-index: 1;
        }
        .hv1-floats {
          position: absolute;
          inset: -55px -75px -55px -75px;
          pointer-events: none;
        }
        .hv1-floats .chip {
          position: absolute;
          padding: 5px 10px;
          border: 1.5px solid var(--ink);
          border-radius: 10px;
          background: var(--cream);
          font-family: "Space Grotesk", sans-serif;
          font-size: 11px;
          font-weight: 500;
          box-shadow: 3px 3px 0 var(--ink);
          white-space: nowrap;
          pointer-events: auto;
          cursor: default;
          transition: box-shadow .18s ease, background .18s ease;
          will-change: transform;
          animation: hv1-float 6s ease-in-out infinite;
          animation-delay: var(--d, 0s);
          transform: rotate(var(--r, 0deg));
        }
        .hv1-floats .chip:hover {
          background: var(--yellow);
          box-shadow: 5px 7px 0 var(--ink);
          animation-play-state: paused;
        }
        .hv1-floats .chip.he {
          font-family: "Heebo", sans-serif;
          font-weight: 600;
          font-size: 12px;
        }
        .hv1-floats .p1  { top:  2%;  right:  4%; --r: -3deg; --d: 0s;   background: var(--cream); }
        .hv1-floats .p2  { top:  6%;  left:   8%; --r:  4deg; --d: .4s;  background: var(--lilac); }
        .hv1-floats .p3  { top: 24%;  right: -4%; --r:  2deg; --d: .8s;  background: var(--cream); }
        .hv1-floats .p4  { top: 28%;  left:  -2%; --r: -3deg; --d: 1.2s; background: var(--yellow-soft); }
        .hv1-floats .p5  { top: 50%;  right:-10%; --r: -2deg; --d: 1.6s; background: var(--cream); }
        .hv1-floats .p6  { top: 56%;  left:  -8%; --r:  3deg; --d: 2.0s; background: var(--coral); }
        .hv1-floats .p7  { bottom:18%; right: 0%; --r:  2deg; --d: 2.4s; background: var(--lilac); }
        .hv1-floats .p8  { bottom:14%; left:   2%; --r: -4deg; --d: 2.8s; background: var(--cream); }
        .hv1-floats .p9  { bottom: 0%; right: 22%; --r:  3deg; --d: 3.2s; background: var(--yellow-soft); }
        .hv1-floats .p10 { bottom:-2%; left:  26%; --r: -2deg; --d: 3.6s; background: var(--cream); }

        /* ── Tablet chip-size + breathing room (symmetric around smiley) ── */
        @media (max-width: 980px) {
          .hv1-floats { inset: -52px -55px !important; }
          .hv1-floats .chip {
            font-size: 7px !important;
            padding: 1px 4px !important;
            box-shadow: 1.5px 1.5px 0 var(--ink) !important;
            border-radius: 4px !important;
            border-width: 1px !important;
          }
          .hv1-floats .chip.he { font-size: 8px !important; }
        }
        @keyframes hv1-float {
          0%, 100% { transform: rotate(var(--r, 0deg)) translate(0, 0); }
          25%      { transform: rotate(calc(var(--r, 0deg) - 1deg)) translate(2px, -6px); }
          50%      { transform: rotate(var(--r, 0deg)) translate(-3px, -2px); }
          75%      { transform: rotate(calc(var(--r, 0deg) + 1deg)) translate(3px, 4px); }
        }

        /* === Signature word animations === */
        .hv1 .hl-block.tilt-l.hl-sway { animation: hv1-sway 1.8s cubic-bezier(0.37, 0, 0.63, 1) infinite alternate !important; transform-origin: center; }
        @keyframes hv1-sway {
          0%   { transform: rotate(-5deg) translateX(-36px); }
          100% { transform: rotate(5deg)  translateX(36px); }
        }
        /* Mobile: softer sway — smaller phone = smaller motion */
        @media (max-width: 880px) {
          .hv1 .hl-block.tilt-l.hl-sway {
            animation: hv1-sway-mobile 2.2s cubic-bezier(0.37, 0, 0.63, 1) infinite alternate !important;
          }
        }
        @keyframes hv1-sway-mobile {
          0%   { transform: rotate(-2deg) translateX(-10px); }
          100% { transform: rotate(2deg)  translateX(10px); }
        }
        .hl-breathe { animation: hv1-breathe 3.6s ease-in-out infinite; transform-origin: center; position: relative; }
        @keyframes hv1-breathe {
          0%, 100% { transform: rotate(2.2deg) scale(1); }
          40%      { transform: rotate(2.2deg) scale(1.12); }
          50%      { transform: rotate(2.2deg) scale(1.1); }
        }
        .word-breathe { position: relative; display: inline-block; }
        /* when breathe + pulse combined: run BOTH animations */
        .hl-breathe.hl-pulse {
          animation: hv1-breathe 3.6s ease-in-out infinite,
                     hv1-pulse   1.6s ease-out infinite;
        }
        @keyframes hv1-pulse {
          0%   { box-shadow: inset 0 0 0 20px rgba(255,106,77,.55), inset 0 0 10px 4px rgba(14,14,16,.15); }
          75%  { box-shadow: inset 0 0 0 0px rgba(255,106,77,0),   inset 0 0 0px 0px rgba(14,14,16,0); }
          100% { box-shadow: inset 0 0 0 0px rgba(255,106,77,0),   inset 0 0 0px 0px rgba(14,14,16,0); }
        }


        .hl-crosshair { position: relative; isolation: isolate; }
        .hl-crosshair .ch {
          position: absolute;
          width: 16px; height: 16px;
          border: 3px solid var(--coral);
          opacity: 0;
          animation: hv1-ch 2.8s ease-in-out infinite;
        }
        .hl-crosshair .ch.tl { top: -12px; left: -12px; border-right: none; border-bottom: none; animation-delay: 0s; }
        .hl-crosshair .ch.tr { top: -12px; right: -12px; border-left: none;  border-bottom: none; animation-delay: 0.07s; }
        .hl-crosshair .ch.bl { bottom: -12px; left: -12px; border-right: none; border-top: none;    animation-delay: 0.14s; }
        .hl-crosshair .ch.br { bottom: -12px; right: -12px; border-left: none;  border-top: none;    animation-delay: 0.21s; }
        @keyframes hv1-ch {
          0%, 85%, 100% { opacity: 0; transform: scale(0.6); }
          15%, 65%      { opacity: 1; transform: scale(1); }
        }

        .hl-line-rest { position: relative; display: inline-block; }
        .hl-line-rest::after {
          content: "";
          position: absolute;
          left: 4%; right: 4%; bottom: -8px;
          height: 3px;
          background: var(--ink);
          border-radius: 2px;
          transform-origin: right;
          animation: hv1-rest 3.2s ease-in-out infinite;
        }
        @keyframes hv1-rest {
          0%, 100% { transform: scaleX(1); opacity: 0.85; }
          50%      { transform: scaleX(0.4); opacity: 0.4; }
        }

        .hv1-strip {
          background: var(--ink);
          color: var(--paper);
          border-top: 2px solid var(--ink);
          overflow: hidden;
          direction: ltr;
          padding: 14px 0;
          font-family: "Heebo", sans-serif;
          font-weight: 600;
          font-size: 17px;
        }
        .hv1-strip-track {
          display: inline-flex;
          flex-wrap: nowrap;
          white-space: nowrap;
          animation: hv1strip 30s linear infinite;
          will-change: transform;
        }
        .hv1-strip-copy {
          display: inline-flex;
          align-items: center;
          flex-shrink: 0;
        }
        .hv1-strip-copy .item { padding: 0 18px; }
        .hv1-strip-copy .bullet { color: var(--yellow); padding: 0; }
        @keyframes hv1strip {
          from { transform: translateX(0); }
          to   { transform: translateX(-50%); }
        }

        @media (prefers-reduced-motion: reduce) {
          .hv1-floats .chip, .hl-sway, .hl-breathe, .hl-pulse, .hl-breathe .ecg path,
          .hl-crosshair .ch, .hl-line-rest::after, .hv1-capacity .pulse,
          .hv1-strip-track { animation: none !important; }
        }
      `}</style>

      <div className="hv1-stage">
        <div className="hv1-left">
          <div className="hv1-eyebrow-row">
            <span className="hv1-eyebrow">
              בניית אתרים <b>·</b> פיתוח עם AI <b>·</b> אוטומציות <b>·</b> מערכות
            </span>
          </div>

          <h1 className="hv1-h1">
            <span className="line">
              <span className="word">פרויקט</span>
              <span className="word">
                <span className="hl-block tilt-l hl-sway">שזז</span>
              </span>
              <span className="dot">.</span>
            </span>
            <span className="line">
              <span className="word">צוות</span>
              <span className="word word-breathe">
                <span className="hl-block tilt-r hl-breathe hl-pulse">שנושם</span>
              </span>
              <span className="dot">.</span>
            </span>
            <span className="line" style={{marginTop: 'clamp(6px, 1vw, 14px)'}}>
              <span className="word">
                <span className="hl-block solid-ink wobble hl-crosshair">
                  פוקוס
                  <span className="ch tl" aria-hidden="true"></span>
                  <span className="ch tr" aria-hidden="true"></span>
                  <span className="ch bl" aria-hidden="true"></span>
                  <span className="ch br" aria-hidden="true"></span>
                </span>
              </span>
              <span className="word">
                <span className="hl-line-rest">שעובד</span>
              </span>
              <span className="dot">.</span>
            </span>
          </h1>

          <p className="hv1-lede">
            <strong>בונים אתרים. מסדרים תהליכים. מחברים מערכות.</strong>
            <br />
            12 שנה בפרסום ושיווק. 3 שנים בניהול פרויקטים טכנולוגיים.
          </p>

          <div className="hv1-cta-row">
            <a
              href={WA_URL}
              className="btn btn-primary"
              target="_blank"
              rel="noopener noreferrer"
              onClick={() => trackWhatsApp('hero')}
            >
              וואטסאפ עכשיו <span>←</span>
            </a>
            <Link to="/services" className="btn btn-secondary">
              לכל השירותים
            </Link>
          </div>

        </div>

        <div className="hv1-right">
          <div className="hv1-smiley-wrap">
            <span className="blob"></span>
            <Smiley size={320} bobble />
            <div className="hv1-floats">
              <span className="chip p1">+ Claude Code</span>
              <span className="chip p2">+ Cursor</span>
              <span className="chip p3">+ n8n</span>
              <span className="chip p4 he">בונה</span>
              <span className="chip p5">+ Make</span>
              <span className="chip p6 he">מאוטמט</span>
              <span className="chip p7">+ Supabase</span>
              <span className="chip p8 he">מסדר</span>
              <span className="chip p9">+ Vercel</span>
              <span className="chip p10 he">מוביל</span>
            </div>
          </div>
        </div>
      </div>

      <div className="hv1-strip" aria-hidden="true">
        <div className="hv1-strip-track">
          {Array.from({ length: 2 }).map((_, k) => (
            <span key={k} className="hv1-strip-copy">
              <span className="item">בניית אתרים</span>
              <span className="bullet">●</span>
              <span className="item">דפי נחיתה</span>
              <span className="bullet">●</span>
              <span className="item">פיתוח עם AI</span>
              <span className="bullet">●</span>
              <span className="item">אוטומציות</span>
              <span className="bullet">●</span>
              <span className="item">מערכות פנימיות</span>
              <span className="bullet">●</span>
            </span>
          ))}
        </div>
      </div>
    </div>
  );
}
